<script setup lang="ts">
import { ECMSType, ECMSPage, EHomePageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'
const { isTablet_rg } = useWindowWidth()
defineProps<{
	disableAos?: boolean
}>()
const { getLocaleLang } = usei18nService()

const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')

const fallbackFeatures = ref()
const fallbackTiles = ref()

if (!pageSections) {
	try {
		const feat = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.FEATURES)
		if (feat) fallbackFeatures.value = feat?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content
		const til = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.TILES)
		if (til) fallbackTiles.value = til?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content
	} catch (error) {
		logger.log(error)
	}
}

const features = computed(() => {
	const section = pageSections?.value?.find((s: IHomePageSectionModel) => s.name === EHomePageSectionType.FEATURES)
	return section?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content ?? fallbackFeatures.value
})

const tiles = computed(() => {
	const section = pageSections?.value?.find((s: IHomePageSectionModel) => s.name === EHomePageSectionType.TILES)
	return section?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content ?? fallbackTiles.value
})
</script>

<template>
	<section class="number-one">
		<h2 :data-aos="disableAos ? undefined : 'fade-up'" class="number-one__title text-display">
			<span class="number-one__title-text number-one__title-text--desktop">{{
				$t('components.number_one.section.rental_cars_nr_1_poland')
			}}</span
			><span class="number-one__title-text number-one__title-text--mobile">{{ $t('components.number_one.section.rental_nr_1_poland') }}</span>
		</h2>
		<div class="number-one__container">
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="200" class="number-one__card number-one__card--delivery">
				<div class="number-one__card-gradient"></div>
				<GlobalImage class="number-one__card-image" src="card-delivery.png" alt="delivery" sizes="640px sm:403px" loading="eager" />
				<h3
					class="number-one__card-title number-one__card-title--delivery"
					v-html="tiles ? tiles[0].text : $t('components.number_one.section.delivery')"></h3>
				<div class="number-one__card-icon number-one__card-icon--lb">
					<GlobalIcon name="location" :width="isTablet_rg ? 20 : 24" />
				</div>
			</div>
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="300" class="number-one__card number-one__card--24">
				<GlobalImage class="number-one__card-image-mask" alt="card-mask-24-2" src="card-mask-24-2.png" sizes="640px sm:403px" />
				<GlobalImage class="number-one__card-image-mask" alt="card-mask-24-3" src="card-mask-24-3.png" sizes="640px sm:403px" />
				<GlobalImage class="number-one__card-image-mask" alt="card-mask-24-1" src="card-mask-24-1.png" sizes="640px sm:403px" />
				<h3 class="number-one__card-title number-one__card-title--24" v-html="tiles ? tiles[1].text : '24/7'"></h3>
				<div class="number-one__card-icon number-one__card-icon--lb number-one__card-icon--24">
					<GlobalIcon name="call-outline" :width="isTablet_rg ? 20 : 24" />
					<span class="number-one__card-icon-text">24/7</span>
				</div>
			</div>
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="400" class="number-one__card number-one__card--unlimited">
				<GlobalImage
					class="number-one__card-image"
					alt="card-unlimited-v2"
					src="card-unlimited-v2.png"
					sizes="640px sm:403px"
					loading="eager" />
				<h3
					class="number-one__card-title number-one__card-title--unlimited"
					v-html="tiles ? tiles[2].text : $t('components.number_one.section.unlimited')"></h3>
				<div class="number-one__card-icon number-one__card-icon--lb">
					<GlobalIcon name="car" :width="isTablet_rg ? 20 : 24" />
				</div>
			</div>
		</div>
		<div class="number-one__container number-one__container--features">
			<GlobalNumberOneFeature
				v-for="(feature, i) in features"
				:key="i"
				:data-aos="disableAos ? undefined : 'fade-up'"
				data-aos-delay="200"
				:iconName="feature.icon"
				:feature-name="feature.name"
				:title="feature.text.toUpperCase()" />
		</div>
	</section>
</template>

<style lang="scss" src="./Section.scss"></style>
